import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import SVG from "../../../Components/SVG";
import InfiniteScrollFooter from "../../../Components/InfiniteScrollFooter";
import { normalizeSymbolCode } from "../tradeUtils";

const TRADE_SYMBOL_QUERY_KEY = "tradeSymbol";
const LEGACY_SYMBOL_QUERY_KEY = "symbol";

const getAccountLabel = (account) => {
  const type = account.challenge_type === "real" ? "حساب واقعی" : "حساب تمرینی";
  const phase = account.phase_type === "phase1" ? "فاز اول" : account.phase_type === "phase2" ? "فاز دوم" : "فاندد";
  return `${type} ${phase} ${account.challenge_category} | ${account.challenge_name}`;
};

export default function AccountSelect({ options = [], defaultValue, symbol, className = "", pagination }) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const selected = options.find((option) => String(option.code) === String(defaultValue));

  useEffect(() => {
    const close = (event) => {
      if (event.key === "Escape" || (event.type === "mousedown" && !containerRef.current?.contains(event.target))) setIsOpen(false);
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", close);
    };
  }, []);

  const selectAccount = (account) => {
    const nextSearchParams = new URLSearchParams(location.search);
    const normalizedSymbol = normalizeSymbolCode(symbol);
    if (normalizedSymbol) nextSearchParams.set(TRADE_SYMBOL_QUERY_KEY, normalizedSymbol);
    else nextSearchParams.delete(TRADE_SYMBOL_QUERY_KEY);
    nextSearchParams.delete(LEGACY_SYMBOL_QUERY_KEY);
    const nextSearch = nextSearchParams.toString();
    window.location.assign(`/trade/${account.code}/trade${nextSearch ? `?${nextSearch}` : ""}`);
  };

  return (
    <div ref={containerRef} className={`relative h-fit ${className}`}>
      <button type="button" onClick={() => setIsOpen((value) => !value)} className="w-full min-w-40 inline-flex items-center justify-between rounded-lg text-sm gap-2.5 bg-zi-bg2-light dark:bg-zi-bg2-dark text-zi-text-light dark:text-zi-text-dark ring-1 ring-inset ring-zi-border-dark hocus:ring-2 py-2.5 pr-3 pl-3">
        <span className="truncate">{selected ? getAccountLabel(selected) : "انتخاب حساب"}</span>
        <SVG name="select" classname={`size-3 shrink-0 stroke-zi-text-light dark:stroke-zi-text-dark ${isOpen ? "rotate-180" : ""}`} />
      </button>
      {isOpen && (
        <div ref={pagination?.scrollRootRef} className="absolute z-50 mt-2 max-h-64 min-w-full overflow-auto rounded-xl border border-zi-border-light dark:border-zi-border-dark bg-zi-bg2-light dark:bg-zi-bg2-dark shadow-lg">
          {options.map((option) => (
            <button key={option.id ?? option.code} type="button" onClick={() => selectAccount(option)} className={`w-full text-right text-xs sm:text-sm px-3 py-2.5 text-zi-text-light dark:text-zi-text-dark hocus:bg-zi-bg1-light dark:hocus:bg-zi-bg1-dark ${String(option.code) === String(defaultValue) ? "bg-zi-bg1-light dark:bg-zi-bg1-dark" : ""}`}>
              {getAccountLabel(option)}
            </button>
          ))}
          {pagination && <InfiniteScrollFooter sentinelRef={pagination.sentinelRef} loading={pagination.loading} error={pagination.error} onRetry={pagination.retry} hasNext={pagination.hasNext} compact />}
        </div>
      )}
    </div>
  );
}
